"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import ArrowRightEcon from "~/components/icons/arrow-right-econ";
import { useLanguage } from "~/translations/loader/use-language";
export default function AboutEcon() {
  const $ = _c(17);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative aspect-video w-full lg:col-span-2 lg:aspect-auto"><CustomImage alt="About E.ON" className="object-cover" fill={true} sizes="(min-width: 1280px) 512px, (min-width: 1024px) 40vw, 100vw" src="images/jobad/about-eon.jpg" /><div className="absolute top-0 left-0 hidden h-full w-full bg-black opacity-30 lg:block" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.jobad_aboutHL) {
    t1 = <h2 className="flex w-full font-bold text-6xl">{t.jobad_aboutHL}</h2>;
    $[1] = t.jobad_aboutHL;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t.jobad_about) {
    t2 = <p className="text-lg lg:text-xl">{t.jobad_about}</p>;
    $[3] = t.jobad_about;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowRightEcon className="mr-2 h-6 w-6" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t.jobad_about_button_title) {
    t4 = <span className="text-white hover:underline">{t.jobad_about_button_title}</span>;
    $[6] = t.jobad_about_button_title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t.jobad_about_button_link || $[9] !== t4) {
    t5 = <CustomLink blank={true} className="mt-6 flex items-center font-bold text-lg md:mt-12" href={t.jobad_about_button_link}>{t3}{t4}</CustomLink>;
    $[8] = t.jobad_about_button_link;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t5) {
    t6 = <div className="flex h-full flex-col justify-center pt-8 lg:pt-0">{t2}{t5}</div>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t6) {
    t7 = <section className="outer-container bg-primary py-container text-white print:hidden" id="about"><div className="inner-container"><div className="flex h-full w-full flex-col lg:relative lg:grid lg:grid-cols-5">{t0}<div className="p-8 lg:col-span-3 lg:p-20 lg:pl-40">{t1}{t6}</div></div></div></section>;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}